import { render } from "./SiteContact.vue?vue&type=template&id=753ae274&scoped=true"
import script from "./SiteContact.vue?vue&type=script&lang=js"
export * from "./SiteContact.vue?vue&type=script&lang=js"

import "./SiteContact.vue?vue&type=style&index=0&id=753ae274&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-753ae274"]])

export default __exports__